import React, { useEffect, useRef, useState } from "react";
import apiRequests from "../axios/config/config";
import toast from "react-hot-toast";
import WebLogo from "../../assets/image/webLogo.png";
import Loading from "../Loading/Loading";
import { useNavigate } from "react-router-dom";
import loginpic from "../../assets/image/loginPic.svg";
import { MdKeyboardArrowDown } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";

export default function ShopInfo() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const dropDownRef = useRef(null);

  const [shopInfo, setShopInfo] = useState({
    city: "",
    address: "",
    type: "",
  });
  const list = ["Toronto", "Montreal", "Québec"];

  useEffect(() => {
    function handleCliCkDropDown(event) {
      if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleCliCkDropDown);
    return () => {
      document.removeEventListener("mousedown", handleCliCkDropDown);
    };
  }, []);

  //  if (!shopInfo.type || !shopInfo.city || !shopInfo.address.trim()) {
  //   toast.error("Fields cannot be empty");
  //   return;
  // }

  return (
    <div className="grid grid-cols-2 md:flex md:h-screen md:justify-center md:items-center font-inter">
      <div className="col-span-1 h-screen md:hidden flex flex-col items-center bg-[#051F33] gap-6 ">
        <div className="mt-12">
          <h3 className=" text-white flex justify-center -mb-2">Welcome to</h3>
          <div className="flex flex-row gap-4">
            <img src={WebLogo} alt="webLogo" width={42} height={42} />
            <h1 className="text-white flex  items-center text-[40px] tracking-wide  ">
              clan
              <span className="text-[#47B26E] font-bold text-4xl relative -bottom-3">
                S
              </span>
              mart
            </h1>
          </div>
        </div>
        <img className="w-30 h-90" src={loginpic} alt="loginImage" />

        <div>
          <p className="text-white text-center">
            Marketplace of trust between <br />
            customers, stores, and home cooks
          </p>
        </div>
      </div>

      {/* card */}
      <div className="flex justify-center h-full items-center p-3 text-center col-span-1 md:col-span-2 md:w-full bg-[#F0E8E4] ">
        <div className="text-black border-2 overflow-hidden rounded-2xl shadow-2xl bg-white p-8 w-[55%] md:w-full items-center justify-center flex flex-col gap-4">
          <div className="flex items-center justify-center gap-3">
            <div className="flex flex-col items-center justify-center">
              <p className="text-3xl font-semibold ">Your shop information</p>
            </div>
          </div>
          <div className="flex flex-col justify-start gap-2 w-full">
            <p>Please choose the type of your shop!</p>
            <div className="flex gap-3 sm:flex-col">
              {/* button */}

              <button
                onClick={() =>
                  setShopInfo((prev) => ({ ...prev, type: "grocery" }))
                }
                className={`flex-1 rounded-lg px-5 py-2 whitespace-nowrap text-center ${
                  shopInfo.type === "grocery"
                    ? "bg-[#47B26E] text-white"
                    : "border border-[#47B26E] text-[#47B26E]"
                }`}
              >
                Grocery shop
              </button>

              <button
                onClick={() =>
                  setShopInfo((prev) => ({
                    ...prev,
                    type: "home-cook",
                  }))
                }
                className={`
    flex-1 border rounded-lg px-4 py-2 whitespace-nowrap text-center
    ${
      shopInfo.type === "home-cook"
        ? "bg-[#E15800] text-white border-[#E15800]"
        : "border-[#E15800] text-[#E15800]"
    }
  `}
              >
                home-cook meal
              </button>
            </div>
            <div ref={dropDownRef} className="relative ">
              <button
                type="button"
                onClick={() => setOpen((p) => !p)}
                className="
          w-full
          bg-white
          border border-neutral-400
          text-gray-500
          rounded-lg
          px-4 py-2
          text-sm
          flex items-center justify-between
          focus:outline-none
        "
              >
                <span className="truncate">{shopInfo.city || "City"}</span>

                <MdKeyboardArrowDown
                  className={`h-5 w-5 transition-transform ${
                    open ? "rotate-180" : ""
                  }`}
                />
              </button>

              {open && (
                <ul
                  className="
            absolute
            left-0 right-0
            mt-2
            bg-white
            border border-gray-200
            rounded-2xl
            shadow-lg
            overflow-hidden
            z-50
          "
                >
                  {list.map((item, index) => (
                    <li
                      key={index}
                      onClick={() => {
                        setShopInfo((prev) => ({
                          ...prev,
                          city: item,
                        }));
                        setOpen(false);
                      }}
                      className="
                px-4 py-2
                text-sm
                text-[#5C5957]
                cursor-pointer
                hover:bg-gray-100
                transition-colors
              "
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div className="border border-neutral-400 flex items-center justify-between px-3 py-2 rounded-lg ">
              <FaLocationDot className=" w-5 h-5 text-neutral-500 mb-12" />
              <textarea
                rows={3}
                className="w-full resize-none outline-none pl-2"
                placeholder="Address"
                value={shopInfo.address}
                onChange={(e) =>
                  setShopInfo((prev) => ({
                    ...prev,
                    address: e.target.value,
                  }))
                }
              />
            </div>
          </div>

          <button
            // onClick={loginAPI}
            className="bg-[#051F33] w-full flex justify-center text-white px-5 py-2 rounded-lg gap-2"
          >
            {loading ? <Loading textColor="white-0" /> : "create account"}
          </button>
        </div>
      </div>
    </div>
  );
}
